import React from 'react'
import PropTypes from 'prop-types'
import { PlayerIdentity } from '../../../group_leader/components/common'
import { playerFullName } from '../../../group_leader/helpers/player'

// PlayerIdentity takes the four fields apart; every caller here has the whole player and was
// spreading them by hand. One name for "show this golfer" keeps that in a single place.
const PlayerRow = ({ player, name }) => (
  <PlayerIdentity
    name={name || playerFullName(player)}
    firstName={player.first_name}
    lastName={player.last_name}
    handicapIndex={player.handicap_index}
  />
)

PlayerRow.propTypes = {
  player: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    handicap_index: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  }).isRequired,
  // Only where the caller already computed it, e.g. a seat that also renders it elsewhere.
  name: PropTypes.string,
}

export default PlayerRow
